"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCatalogAttribute = exports.CatalogAttributeBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var groupFactory_1 = require("./groupFactory");
var builder_1 = require("../builder");
var attributeFactory_1 = require("../metadata/attributeFactory");
var displayFormFactory_1 = require("../metadata/displayFormFactory");
/**
 * Catalog attribute builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogAttributeBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogAttributeBuilder, _super);
    function CatalogAttributeBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogAttributeBuilder.prototype.attribute = function (attributeOrRef, modifications) {
        if (!sdk_backend_spi_1.isAttributeMetadataObject(attributeOrRef)) {
            this.item.attribute = attributeFactory_1.newAttributeMetadataObject(attributeOrRef, modifications);
        }
        else {
            this.item.attribute = attributeOrRef;
        }
        return this;
    };
    CatalogAttributeBuilder.prototype.defaultDisplayForm = function (displayFormOrRef, modifications) {
        if (!sdk_backend_spi_1.isAttributeDisplayFormMetadataObject(displayFormOrRef)) {
            this.item.defaultDisplayForm = displayFormFactory_1.newAttributeDisplayFormMetadataObject(displayFormOrRef, modifications);
        }
        else {
            this.item.defaultDisplayForm = displayFormOrRef;
        }
        return this;
    };
    CatalogAttributeBuilder.prototype.displayForms = function (displayForms) {
        this.item.displayForms = displayForms;
        return this;
    };
    CatalogAttributeBuilder.prototype.geoPinDisplayForms = function (displayForms) {
        this.item.geoPinDisplayForms = displayForms;
        return this;
    };
    CatalogAttributeBuilder.prototype.toExecutionModel = function (modifications) {
        var _this = this;
        if (modifications === void 0) { modifications = identity_1.default; }
        if (!this.item.defaultDisplayForm) {
            throw new Error("Cannot convert catalog attribute to execution model, no displayForm found!");
        }
        var defaultModifications = function (a) { var _a; return a.alias((_a = _this.item.defaultDisplayForm) === null || _a === void 0 ? void 0 : _a.title); };
        return sdk_model_1.newAttribute(this.item.defaultDisplayForm.ref, function (m) { return modifications(defaultModifications(m)); });
    };
    return CatalogAttributeBuilder;
}(groupFactory_1.GroupableCatalogItemBuilder));
exports.CatalogAttributeBuilder = CatalogAttributeBuilder;
/**
 * Catalog attribute factory
 *
 * @param modifications - catalog attribute builder modifications to perform
 * @returns created catalog attribute
 * @beta
 */
exports.newCatalogAttribute = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogAttributeBuilder, { type: "attribute" }, modifications);
};
//# sourceMappingURL=attributeFactory.js.map